import React, { useEffect, useState } from "react";
import RecommendationCardV2 from "./RecommendationCardV2";
import "./Recommender.css";
import downVector from "./downVector.png";
import upVector from "./upVector.png";
import NonEligibleCardV2 from "./NonEligibleCardV2";
import RecommendationCreditCard from "./RecommendationCreditCard";
import _ from "lodash";

export default function RecommendationCategoryCardV2(props) {
  const {
    title,
    brands,
    customer,
    notEligible,
    categoryId,
    interestsArray,
    // ineligibleBrand,
    // setIneligibleBrand,
    customerDetails,
    hg,
    coc,
    isCreditScoreCheck,
    flags={},
  } = props;
  const [ineligibleBrand, setIneligibleBrand] = useState([]);

  const [hiddenNE, setHiddenNE] = useState(true);
  const [brandList, setBrandList] = useState(null);

  React.useEffect(() => {
    if (categoryId === "15") {
      if (flags?.scb_cc_brand?.value) {
        const scbFlag = JSON.parse(flags?.scb_cc_brand?.value);
        if (!scbFlag.show) {
          const filterBrands = brands.filter((brand) => String(brand.id) != "197");
          setBrandList(filterBrands);
        } else {
          setBrandList(null);
        }
      } else {
        setBrandList(null);
      }
    } else {
      setBrandList(null);
    }
  }, [brands,flags]);

  const fetchNotEligible = () => {
    const sortedNotEligible = _(notEligible)
      .groupBy("id")
      .sortBy((id) => notEligible.indexOf(id[0]))
      .map((g) =>
        _.mergeWith({}, ...g, (obj, src) =>
          _.isArray(obj) ? obj.concat(src) : undefined
        )
      )
      .value();
    const res = sortedNotEligible.filter((item) => item.id === categoryId);
    // console.log("notEligible", res);
    if (res.length > 0) {
      setIneligibleBrand(res);
    }
  };

  const showIneligibleBrand = () => {
    // console.log("showIneligibleBrand", ineligibleBrand);

    return ineligibleBrand[0]?.partners?.map((items) => {
      const brandContent = JSON.parse(items.brandComms);
      return (
        <NonEligibleCardV2
          partnerDetails={brandContent}
          // partnerId={brandContent.id}
          // customer={customer}
        />
      );
    });
  };

  useEffect(() => {
    showIneligibleBrand();
  }, [ineligibleBrand]);

  useEffect(() => {
    fetchNotEligible();
  }, []);

  const showNonEligible = () => {
    setHiddenNE(false);
  };
  const hideNonEligible = () => {
    setHiddenNE(true);
  };

  const brandPartners = () => {
    return (brandList || brands).map((items) => {
      let brandContent = JSON.parse(items.brandComms);
      brandContent = {
        attributionType: items.attributionType,
        ...brandContent,
      }
      if (categoryId == "15" || categoryId == "18") {
        return (
          <RecommendationCreditCard
            partnerDetails={brandContent}
            partnerId={brandContent.id}
            customer={customer}
            customerDetails={customerDetails}
            hg={hg}
            coc={coc}
            isCreditScoreCheck={isCreditScoreCheck}
          />
        );
      }
      return (
        <RecommendationCardV2
          partnerDetails={brandContent}
          partnerId={brandContent.id}
          customer={customer}
          customerDetails={customerDetails}
          categoryId={categoryId}
          isCreditScoreCheck={isCreditScoreCheck}
        />
      );
    });
  };
  if(brandList != null && brandList.length <= 0) {
    return null;
  } 

  return (
    <div className="mainCard">
      <div
        style={{
          textAlign: "center",
          marginTop: "-20px",
          marginBottom: "20px",
        }}
      >
        <div>
          <img alt="" src="" />
        </div>
        <div>
          <p
            style={{
              fontSize: "16px",
              color: "#6C63FF",
              fontWeight: "600",
            }}
          >
            {title}
          </p>
        </div>
      </div>
      {brandPartners()}{" "}
      {/* <RecommendationCardV2 />
      <RecommendationCardV2 /> */}
      {interestsArray.length > 0 ? (
        <></>
      ) : (
        <>
          {hiddenNE && ineligibleBrand.length > 0 ? (
            <div
              style={{
                display: "flex",
                // border:"1px solid red",
                height: "20px",
                justifyContent: "center",
                color: "#747474",
                fontWeight: "500",
                fontSize: "15px",
                alignItems: "center",
              }}
              onClick={showNonEligible}
            >
              <div
                style={{
                  marginRight: "10px",
                  fontSize: "0.8rem",
                }}
              >
                {ineligibleBrand[0].partners.length} brands - not eligible
              </div>
              <div>
                <img
                  alt=""
                  src={downVector}
                  style={{ height: "30%", opacity: "0.3", width: "0.7rem" }}
                />
              </div>
            </div>
          ) : (
            showIneligibleBrand()
          )}
          {!hiddenNE ? (
            <div
              style={{
                display: "flex",
                // border:"1px solid red",
                height: "20px",
                justifyContent: "center",
                color: "#747474",
                fontWeight: "500",
                fontSize: "15px",
              }}
              onClick={hideNonEligible}
            >
              <div
                style={{
                  marginRight: "10px",
                }}
              >
                <p>Show Less</p>
              </div>
              <div>
                <img alt="" src={upVector} style={{ height: "30%" }} />
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
}
